import {useParams} from 'react-router'

export const useSuiteHierarchyId = (): string | null => {
  const {hierarchyId} = useParams<{hierarchyId: string}>()
  return hierarchyId ?? null
}
